import { MessageStatusDto } from '@/features/dashboard/messages/types/MessageStatusDto.ts';
import {
  mapToUserMessageStatus,
  userMessageStatusTableConfig,
} from '@/features/dashboard/messages/types/UserMessageStatus.utils.ts';

export const messageStatusExportRender = (value: unknown): string => {
  const status = value as MessageStatusDto | null | undefined;
  if (!status) return '';
  const userStatus = mapToUserMessageStatus(status);
  return userMessageStatusTableConfig[userStatus]?.label ?? '';
};
